import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { ShieldWarning, SignOut } from "@phosphor-icons/react";

export default function NoAccess() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6" data-testid="no-access-screen">
      <div className="max-w-md w-full text-center border border-border rounded-lg bg-card p-10 shadow-sm">
        <div className="mx-auto mb-5 h-14 w-14 rounded-full bg-amber-50 flex items-center justify-center">
          <ShieldWarning size={30} weight="bold" className="text-amber-600" />
        </div>
        <h1 className="text-2xl font-semibold text-foreground mb-2">No access yet</h1>
        <p className="text-sm text-muted-foreground leading-relaxed">
          Your login is active{user?.email ? <> as <span className="font-medium text-foreground">{user.email}</span></> : ""}, but no modules have been assigned to you yet.
          Please contact your administrator to be granted access.
        </p>
        <Button variant="outline" className="rounded-md mt-8" onClick={logout} data-testid="no-access-logout">
          <SignOut size={16} weight="bold" className="mr-2" /> Sign out
        </Button>
      </div>
    </div>
  );
}
